
























































import Tabs from "../core/Tabs/Tabs.vue";
import Tab from "../core/Tabs/Tab.vue";
import DashboardPanel from "./DashboardPanel.vue";
import InventairePanel from "./InventairePanel.vue";
import MaintenancePanel from "./MaintenancePanel.vue";
import HistoriquePanel from "./HistoriquePanel.vue";
import MouvementPanel from "./MouvementPanel.vue";

export default {
    name: "SuiviMateriel",
    components: {
        Tabs,
        Tab,
        DashboardPanel,
        InventairePanel,
        MaintenancePanel,
        HistoriquePanel,
        MouvementPanel,
    },
    data() {
        return {
            // null = onglets ; "out" / "in" = panneau mouvement seul.
            mouvementType: null,
            refreshKey: 0,
            toast: null,
            toastSeq: 0,
            toastTimeout: null,
        };
    },
    methods: {
        showToast: function (message, kind = "success") {
            let self = this;
            self.toastSeq++;
            self.toast = {
                id: self.toastSeq,
                message: message,
                kind: kind,
            };

            if (self.toastTimeout) {
                clearTimeout(self.toastTimeout);
            }
            self.toastTimeout = setTimeout(function () {
                self.toast = null;
                self.toastTimeout = null;
            }, 3200);
        },
        onToast: function (payload) {
            if (!payload) {
                return;
            }
            this.showToast(payload.message, payload.kind || "success");
        },
        openMouvement: function (type) {
            this.mouvementType = type;
        },
        closeMouvement: function () {
            this.mouvementType = null;
        },
        bumpRefresh: function () {
            this.refreshKey++;
        },
        // `MouvementPanel` émet déjà son propre `toast` de confirmation
        // avant `saved` : on se contente de refermer et de rafraîchir.
        onMouvementSaved: function () {
            this.closeMouvement();
            this.bumpRefresh();
        },
    },
    beforeDestroy() {
        if (this.toastTimeout) {
            clearTimeout(this.toastTimeout);
        }
    },
};
